import * as React from "react";
const SvgFiRrSushiRoll = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sushi-roll_svg__a)">
      <path
        fill="#062147"
        d="M24 6.5C24 2.855 18.729 0 12 0S0 2.855 0 6.5v11C0 21.267 5.047 24 12 24s12-2.733 12-6.5zM12 2c5.894 0 10 2.372 10 4.5S17.894 11 12 11 2 8.628 2 6.5 6.107 2 12 2m0 20c-5.514 0-10-2.019-10-4.5v-7.362C4.132 11.876 7.778 13 12 13s7.868-1.124 10-2.862V17.5c0 2.481-4.486 4.5-10 4.5M5.292 7.137c-.39-.291-.39-.982 0-1.273C6.433 5.011 8.735 4.001 12 4.001s5.566 1.011 6.707 1.863c.39.291.39.982 0 1.273C17.566 7.99 15.265 9 12 9S6.434 7.989 5.292 7.137"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sushi-roll_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSushiRoll;
